import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-down-right', 'IconChevronDownRight', [["path",{"d":"M16 8v8h-8","key":"svg-0"}]]);